module.exports = __webpack_public_path__ + "img/male-infant-hand.d802758f.svg";